import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ScrollPanel } from "primeng/scrollpanel";
import { PrimeNGConfig } from "primeng/api";
import { UserHelperService } from "@main/users/user-helper.service";
import { Event as RouterEvent, NavigationEnd, Router } from "@angular/router";
import { filter, Subject, takeUntil } from "rxjs";

@Component({
    selector: "ultima-layout",
    templateUrl: "./ultima.component.html",
    styleUrls: ["./ultima.component.scss"]
})
export class UltimaComponent implements OnInit, AfterViewInit, OnDestroy {
    private readonly destroyed$ = new Subject<void>();

    layoutMode = "collapsed";
    darkMenu = false;
    profileMode = "top";
    topbarMenuActive: boolean;
    collapsedMenuActive = true;
    staticMenuDesktopInactive: boolean;
    staticMenuMobileActive: boolean;
    rightPanelActive: boolean;
    rightPanelClick: boolean;
    menuClick = true;
    topbarItemClick: boolean;
    activeTopbarItem: any;
    menuHoverActive: boolean;
    configActive: boolean;
    configClick: boolean;
    inputStyle = "outlined";
    ripple = true;
    compactMode = false;
    shouldHideScrollPanel: boolean = false;
    @ViewChild("layoutMenuScroller", { static: true }) private layoutMenuScrollerViewChild: ScrollPanel;

    constructor(
        private cd: ChangeDetectorRef,
        private userHelperService: UserHelperService,
        private primengConfig: PrimeNGConfig,
        private router: Router
    ) {}

    get isTablet(): boolean {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    get isDesktop(): boolean {
        return window.innerWidth > 1024;
    }

    get isMobile(): boolean {
        return window.innerWidth <= 640;
    }

    get isOverlay(): boolean {
        return this.layoutMode === "overlay";
    }

    get isStatic(): boolean {
        return this.layoutMode === "static";
    }

    get isHorizontal(): boolean {
        return this.layoutMode === "horizontal";
    }

    get isSlim(): boolean {
        return this.layoutMode === "slim";
    }

    get isCollapsed() {
        return this.layoutMode === "collapsed";
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.router.events
            .pipe(
                takeUntil(this.destroyed$),
                filter((e: RouterEvent): e is NavigationEnd => e instanceof NavigationEnd)
            )
            .subscribe(e => {
                if (window.innerWidth < 576) {
                    this.collapsedMenuActive = true;
                }
            });
            this.updateMenuVisibility(window.innerWidth);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (!this.isGenericPatient && this.layoutMenuScrollerViewChild) {
                this.layoutMenuScrollerViewChild.refresh();
            }
        }, 10);
    }

    ngOnDestroy(): void {
        if (this.layoutMenuScrollerViewChild) {
            this.layoutMenuScrollerViewChild.refresh();
        }
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    
    updateMenuVisibility(innerWidth: number) {
        this.shouldHideScrollPanel = this.isCollapsed && this.collapsedMenuActive && innerWidth <= 576;
    }

    @HostListener("window:resize")
    onResize(): void {
        this.updateMenuVisibility(window.innerWidth);
        this.cd.detectChanges();
    }

    onLayoutClick() {
        
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.menuClick) {
            if (!this.collapsedMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }
        }

        if (!this.rightPanelClick) {
            this.rightPanelActive = false;
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        this.updateMenuVisibility(window.innerWidth);

        this.configClick = false;
        this.topbarItemClick = false;
        this.menuClick = false;
        this.rightPanelClick = false;
       
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.topbarMenuActive = false;

        if (this.isCollapsed) {
            this.collapsedMenuActive = !this.collapsedMenuActive;
        } else {
            if (this.isDesktop) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    get isGenericPatient() {
        return this.userHelperService.isGenericPatient;
    }

    hideOverlayMenu() {
        this.collapsedMenuActive = false;
        this.staticMenuMobileActive = false;
    }
}
